import _ from 'lodash';

export default function checkForColumnFilter(localStorageColumns, columns) {
	if (localStorageColumns) {
		localStorageColumns.forEach(outerElement => {
			if (outerElement.filter) {
				columns.forEach(innerElement => {
					if (innerElement.key === outerElement.key) {
						innerElement.filter = outerElement.filter;
						return;
					}
				});
			}
		});
	}
}

export const deleteTableFilterExpression = (tableFilterExpressions, column) => {
	if (tableFilterExpressions.length != 0) {
		_.forEachRight(tableFilterExpressions, (item, index) => {
			if (item) {
				if (item.expressions) {
					_.forEachRight(item.expressions, (innerItem, index) => {
						if (innerItem.category === column.key) {
							item.expressions.splice(index, 1);
						}
						if (item.expressions.length == 0) {
							let outerIndex = _.findIndex(tableFilterExpressions, x => x == item);
							tableFilterExpressions.splice(outerIndex, 1);
						}

						//Remove if both applied
						if (
							column.key === 'fulfillmentOrderId' &&
							(innerItem.category == 'DeliveryReplacement' || innerItem.category == 'FulfillmentOrderErrorId')
						) {
							item.expressions.splice(index, 1);
							return;
						}
					});
				} else {
					if (item.category === column.key) {
						tableFilterExpressions.splice(index, 1);
						return;
					}

					//Remove if one applied
					if (
						column.key === 'fulfillmentOrderId' &&
						(item.category == 'DeliveryReplacement' || item.category == 'FulfillmentOrderErrorId')
					) {
						tableFilterExpressions.splice(index, 1);
						return;
					}
				}
			} else {
				return;
			}
		});
	}
};
